// OneBoutiq — scripts propios (vanilla, sin librerias externas)
function obInitTodo() {
  try { initReveal(); } catch (e) {}
  try { initComparador(); } catch (e) {}
  try { initGaleriaProducto(); } catch (e) {}
  try { initVariantesProducto(); } catch (e) {}
  try { initContadores(); } catch (e) {}
  try { initBarraFija(); } catch (e) {}
  try { initBarraLanding(); } catch (e) {}
  try { initFechasEnvio(); } catch (e) {}
}

function obAbrirHoja(cfg) {
  var hoja = document.createElement('div');
  hoja.className = 'ob-hoja';
  hoja.innerHTML =
    '<div class="ob-hoja__fondo" data-cerrar></div>' +
    '<div class="ob-hoja__panel" role="dialog" aria-modal="true">' +
      '<div class="ob-hoja__cab"><strong></strong>' +
      '<button type="button" class="ob-hoja__x" data-cerrar>&times;</button></div>' +
      '<div class="ob-hoja__cuerpo"><img class="ob-hoja__foto" alt=""><div class="ob-hoja__opciones"></div></div>' +
      '<div class="ob-hoja__pie"><span class="ob-hoja__precio"></span><button type="button" class="ob-boton ob-hoja__ok"></button></div>' +
    '</div>';
  hoja.querySelector('.ob-hoja__cab strong').textContent = cfg.txtElegir || '';
  hoja.querySelector('.ob-hoja__x').setAttribute('aria-label', cfg.txtCerrar || '');
  var cont = hoja.querySelector('.ob-hoja__opciones');
  var foto = hoja.querySelector('.ob-hoja__foto');
  var hPrecio = hoja.querySelector('.ob-hoja__precio');
  var ok = hoja.querySelector('.ob-hoja__ok');
  var filas = [];

  cfg.grupos.forEach(function (g) {
    var caja = document.createElement('div');
    caja.className = 'ob-hoja__grupo';
    var t = document.createElement('div');
    t.className = 'ob-hoja__etiqueta';
    t.textContent = g.label || '';
    caja.appendChild(t);
    var fila = document.createElement('div');
    fila.className = 'ob-hoja__chips';
    g.opciones.forEach(function (texto, i) {
      var chip = document.createElement('button');
      chip.type = 'button';
      chip.className = 'ob-chip';
      chip.textContent = texto;
      chip.addEventListener('click', function () {
        g.set(i);
        setTimeout(refrescar, 30);
      });
      fila.appendChild(chip);
    });
    caja.appendChild(fila);
    cont.appendChild(caja);
    filas.push({ g: g, chips: fila.children });
  });

  function refrescar() {
    filas.forEach(function (f) {
      Array.prototype.forEach.call(f.chips, function (c, i) {
        c.classList.toggle('ob-chip--activo', f.g.get() === i);
      });
    });
    hPrecio.textContent = cfg.precio();
    ok.textContent = cfg.boton();
    ok.disabled = !!cfg.deshabilitado();
    var f = cfg.foto();
    if (f) { foto.src = f; foto.style.display = ''; } else { foto.style.display = 'none'; }
  }
  function cerrar() {
    document.removeEventListener('keydown', onKey);
    document.body.classList.remove('ob-hoja-abierta');
    if (hoja.parentNode) hoja.parentNode.removeChild(hoja);
  }
  function onKey(e) { if (e.key === 'Escape') cerrar(); }

  hoja.addEventListener('click', function (e) { if (e.target.hasAttribute('data-cerrar')) cerrar(); });
  ok.addEventListener('click', function () { cerrar(); cfg.confirmar(); });
  document.addEventListener('keydown', onKey);
  document.body.classList.add('ob-hoja-abierta');
  document.body.appendChild(hoja);
  refrescar();
}

function obMostrarBarra(barra, v) {
  document.body.classList.toggle('ob-barra-fija-on', v);
  if (v) {
    barra.hidden = false;
    requestAnimationFrame(function () { barra.classList.add('ob-barra-fija--visible'); });
  } else {
    barra.classList.remove('ob-barra-fija--visible');
    setTimeout(function () { if (!barra.classList.contains('ob-barra-fija--visible')) barra.hidden = true; }, 300);
  }
}

// Ficha de compra: barra fija que reutiliza el formulario de la página.
function initBarraFija() {
  var barra = document.querySelector('[data-ob-barra-fija]');
  if (!barra || barra.getAttribute('data-ob-init')) return;
  barra.setAttribute('data-ob-init', '1');
  var comprar = document.querySelector('.ob-producto [data-ob-boton-comprar]');
  var precio = document.querySelector('.ob-producto [data-ob-precio]');
  var bBoton = barra.querySelector('[data-ob-barra-boton]');
  var bPrecio = barra.querySelector('[data-ob-barra-precio]');
  if (!comprar || !bBoton) return;

  function sync() {
    bBoton.textContent = comprar.textContent.trim();
    bBoton.disabled = comprar.disabled;
    if (precio && bPrecio) bPrecio.textContent = precio.textContent;
  }
  sync();
  if ('MutationObserver' in window) {
    var mo = new MutationObserver(sync);
    mo.observe(comprar, { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['disabled'] });
    if (precio) mo.observe(precio, { childList: true, characterData: true, subtree: true });
  }

  var selects = Array.prototype.filter.call(
    document.querySelectorAll('.ob-producto [data-ob-opcion]'),
    function (el) { return el.tagName === 'SELECT' && el.options.length > 1; }
  );
  var mainImg = document.querySelector('.ob-producto [data-ob-galeria-principal]');
  var variantesDatos = [];
  try { variantesDatos = JSON.parse(document.querySelector('.ob-producto [data-ob-variantes-json]').textContent); } catch (e) {}
  var todasOpciones = document.querySelectorAll('.ob-producto [data-ob-opcion]');
  function fotoVariante() {
    var valores = Array.prototype.map.call(todasOpciones, function (o) { return o.value; });
    for (var n = 0; n < variantesDatos.length; n++) {
      var v = variantesDatos[n], ok = true;
      for (var i = 0; i < valores.length; i++) { if (v.options[i] !== valores[i]) { ok = false; break; } }
      if (ok && v.imagen) return v.imagen;
    }
    return mainImg ? (mainImg.currentSrc || mainImg.src) : '';
  }

  bBoton.addEventListener('click', function () {
    if (comprar.disabled) return;
    if (!selects.length) { comprar.click(); return; }
    obAbrirHoja({
      txtElegir: barra.getAttribute('data-txt-elegir'),
      txtCerrar: barra.getAttribute('data-txt-cerrar'),
      grupos: selects.map(function (sel) {
        var lab = sel.parentNode.querySelector('.ob-producto-opcion-label');
        return {
          label: lab ? lab.textContent : '',
          opciones: Array.prototype.map.call(sel.options, function (o) { return o.textContent.trim(); }),
          get: function () { return sel.selectedIndex; },
          set: function (i) { sel.selectedIndex = i; sel.dispatchEvent(new Event('change', { bubbles: true })); }
        };
      }),
      precio: function () { return precio ? precio.textContent : ''; },
      boton: function () { return comprar.textContent.trim(); },
      deshabilitado: function () { return comprar.disabled; },
      foto: fotoVariante,
      confirmar: function () { comprar.click(); }
    });
  });

  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (entradas) { obMostrarBarra(barra, !entradas[0].isIntersecting); }).observe(comprar);
  } else {
    obMostrarBarra(barra, true);
  }
}

// Página de presentación: barra fija con selector propio que añade a la cesta.
function initBarraLanding() {
  var barra = document.querySelector('[data-ob-barra-landing]');
  if (!barra || barra.getAttribute('data-ob-init')) return;
  barra.setAttribute('data-ob-init', '1');
  var dataEl = document.querySelector('[data-ob-landing-variantes]');
  var bBoton = barra.querySelector('[data-ob-barra-boton]');
  var bPrecio = barra.querySelector('[data-ob-barra-precio]');
  if (!dataEl || !bBoton) return;
  var datos;
  try { datos = JSON.parse(dataEl.textContent); } catch (e) { return; }

  var sel = datos.raw.map(function () { return 0; });
  var inicial = null;
  datos.variantes.forEach(function (v) { if (v.id === datos.inicial) inicial = v; });
  if (inicial) {
    datos.raw.forEach(function (vals, i) {
      var k = vals.indexOf(inicial.options[i]);
      sel[i] = k < 0 ? 0 : k;
    });
  }

  function actual() {
    for (var n = 0; n < datos.variantes.length; n++) {
      var v = datos.variantes[n];
      var ok = true;
      for (var i = 0; i < datos.raw.length; i++) {
        if (v.options[i] !== datos.raw[i][sel[i]]) { ok = false; break; }
      }
      if (ok) return v;
    }
    return null;
  }
  function textoBoton() {
    var v = actual();
    return (v && !v.available) ? barra.getAttribute('data-txt-agotado') : barra.getAttribute('data-txt-anadir');
  }
  function sync() {
    var v = actual();
    if (bPrecio) { bPrecio.textContent = v ? v.price : ''; if (v && v.antes) { var sAntes = document.createElement('s'); sAntes.className = 'ob-antes'; sAntes.textContent = v.antes; bPrecio.appendChild(document.createTextNode(' ')); bPrecio.appendChild(sAntes); } }
    bBoton.textContent = textoBoton();
    bBoton.disabled = !!(v && !v.available);
  }
  sync();

  function anadir() {
    var v = actual();
    if (!v) return;
    bBoton.disabled = true;
    fetch(barra.getAttribute('data-cart-add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: v.id, quantity: 1 })
    })
      .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function () { window.location.href = barra.getAttribute('data-cart-url'); })
      .catch(function () { sync(); });
  }

  var grupos = [];
  datos.opciones.forEach(function (o, i) {
    if (o.values.length < 2) return;
    grupos.push({
      label: o.name,
      opciones: o.values,
      get: function () { return sel[i]; },
      set: function (k) { sel[i] = k; sync(); }
    });
  });

  bBoton.addEventListener('click', function () {
    var v = actual();
    if (v && !v.available) return;
    if (!grupos.length) { anadir(); return; }
    obAbrirHoja({
      txtElegir: barra.getAttribute('data-txt-elegir'),
      txtCerrar: barra.getAttribute('data-txt-cerrar'),
      grupos: grupos,
      precio: function () { var x = actual(); return x ? x.price : ''; },
      boton: textoBoton,
      deshabilitado: function () { var x = actual(); return !!(x && !x.available); },
      foto: function () { var x = actual(); return (x && x.image) || datos.imagen || ''; },
      confirmar: anadir
    });
  });

  var objetivo = document.querySelector('.ob-hero .ob-hero-acciones .ob-boton');
  if (objetivo && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entradas) { obMostrarBarra(barra, !entradas[0].isIntersecting); }).observe(objetivo);
  } else {
    obMostrarBarra(barra, true);
  }
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', obInitTodo);
} else {
  obInitTodo();
}

function initContadores() {
  var els = document.querySelectorAll('[data-ob-contador]');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.textContent = el.getAttribute('data-ob-contador-fin'); });
    return;
  }
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      obs.unobserve(entry.target);
      var el = entry.target;
      var finStr = el.getAttribute('data-ob-contador-fin') || '0';
      var fin = parseFloat(finStr) || 0;
      var decimales = (finStr.split('.')[1] || '').length;
      var sufijo = el.getAttribute('data-ob-contador-sufijo') || '';
      var duracion = 1400;
      var inicio = null;
      function paso(ts) {
        if (!inicio) inicio = ts;
        var progreso = Math.min((ts - inicio) / duracion, 1);
        var bruto = fin * (1 - Math.pow(1 - progreso, 3));
        var valor = decimales > 0 ? bruto.toFixed(decimales) : Math.round(bruto);
        el.textContent = valor + sufijo;
        if (progreso < 1) requestAnimationFrame(paso);
      }
      requestAnimationFrame(paso);
    });
  }, { threshold: 0.4 });
  els.forEach(function (el) { obs.observe(el); });
}

function initReveal() {
  var els = document.querySelectorAll('.ob-reveal, .ob-reveal-stagger');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('ob-visible'); });
    return;
  }
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('ob-visible');
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.18, rootMargin: '0px 0px -60px 0px' });
  els.forEach(function (el) { obs.observe(el); });
}

function initComparador() {
  document.querySelectorAll('[data-ob-comparador]').forEach(function (wrap) {
    var handle = wrap.querySelector('[data-ob-comparador-handle]');
    var after = wrap.querySelector('[data-ob-comparador-after]');
    if (!handle || !after) return;
    var dragging = false;

    function setPos(clientX) {
      var rect = wrap.getBoundingClientRect();
      var pct = ((clientX - rect.left) / rect.width) * 100;
      pct = Math.max(2, Math.min(98, pct));
      after.style.clipPath = 'inset(0 0 0 ' + pct + '%)';
      handle.style.left = pct + '%';
    }

    handle.addEventListener('pointerdown', function (e) {
      dragging = true;
      handle.setPointerCapture(e.pointerId);
    });
    handle.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      setPos(e.clientX);
    });
    handle.addEventListener('pointerup', function () { dragging = false; });
    wrap.addEventListener('click', function (e) {
      if (e.target === handle) return;
      setPos(e.clientX);
    });
  });
}

function initGaleriaProducto() {
  document.querySelectorAll('[data-ob-galeria]').forEach(function (galeria) {
    var main = galeria.querySelector('[data-ob-galeria-principal]');
    var thumbs = galeria.querySelectorAll('[data-ob-galeria-thumb]');
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var full = thumb.getAttribute('data-full');
        if (!full) return;
        main.style.opacity = '0';
        setTimeout(function () {
          main.src = full;
          main.style.opacity = '1';
        }, 140);
        thumbs.forEach(function (t) { t.classList.remove('ob-thumb-activo'); });
        thumb.classList.add('ob-thumb-activo');
      });
    });

    var prev = galeria.querySelector('[data-ob-gal-prev]');
    var next = galeria.querySelector('[data-ob-gal-next]');
    var contador = galeria.querySelector('[data-ob-gal-contador]');
    var list = Array.prototype.slice.call(thumbs);

    function indiceActual() {
      var cur = (main.getAttribute('src') || '').split('?')[0];
      for (var i = 0; i < list.length; i++) {
        if ((list[i].getAttribute('data-full') || '').split('?')[0] === cur) return i;
      }
      for (var j = 0; j < list.length; j++) {
        if (list[j].classList.contains('ob-thumb-activo')) return j;
      }
      return 0;
    }
    function actualizarContador() {
      if (contador) contador.textContent = (indiceActual() + 1) + ' / ' + list.length;
    }
    function ir(delta) {
      var n = (indiceActual() + delta + list.length) % list.length;
      list[n].click();
      setTimeout(actualizarContador, 200);
    }

    if (list.length > 1) {
      if (prev) { prev.hidden = false; prev.addEventListener('click', function () { ir(-1); }); }
      if (next) { next.hidden = false; next.addEventListener('click', function () { ir(1); }); }
      if (contador) { contador.hidden = false; actualizarContador(); }
      if ('MutationObserver' in window) {
        new MutationObserver(actualizarContador).observe(main, { attributes: true, attributeFilter: ['src'] });
      }
      var x0 = null;
      var marco = main.parentNode;
      marco.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      marco.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        x0 = null;
        if (Math.abs(dx) > 40) ir(dx < 0 ? 1 : -1);
      }, { passive: true });
    }
  });
}

function initVariantesProducto() {
  document.querySelectorAll('[data-ob-producto-form]').forEach(function (form) {
    var dataEl = form.querySelector('[data-ob-variantes-json]');
    if (!dataEl) return;
    var variantes;
    try { variantes = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var selects = form.querySelectorAll('[data-ob-opcion]');
    var idInput = form.querySelector('input[name="id"]');
    // El precio se muestra fuera del <form>, así que lo buscamos en el contenedor del producto.
    var ambito = form.closest('.ob-producto-grid') || form.closest('.ob-producto') || document;
    var precioEl = ambito.querySelector('[data-ob-precio]');
    var compareEl = ambito.querySelector('[data-ob-precio-comparado]');
    var botonComprar = form.querySelector('[data-ob-boton-comprar]');

    function moneda(centavos) {
      var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
      var monto = centavos / 100;
      var locale = document.documentElement.lang || 'es';
      try {
        return new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format(monto);
      } catch (e) {
        return '€' + monto.toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      }
    }

    function actualizar() {
      var valores = [];
      selects.forEach(function (s) { valores.push(s.value); });
      var encontrada = variantes.find(function (v) {
        return v.options.every(function (opt, i) { return opt === valores[i]; });
      });
      if (!encontrada) return;
      idInput.value = encontrada.id;
      if (precioEl) precioEl.textContent = moneda(encontrada.price);
      if (compareEl) {
        if (encontrada.compare_at_price && encontrada.compare_at_price > encontrada.price) {
          compareEl.textContent = moneda(encontrada.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
      var stockEl = ambito.querySelector('[data-ob-stock-bajo]');
      if (stockEl) {
        var q = encontrada.stock;
        if (typeof q === 'number' && q > 0 && q < 10) {
          stockEl.textContent = q === 1 ? stockEl.getAttribute('data-txt-una') : stockEl.getAttribute('data-txt-pocas').replace('NN', q);
          stockEl.hidden = false;
        } else {
          stockEl.hidden = true;
        }
      }
      if (botonComprar) {
        if (encontrada.available) {
          botonComprar.disabled = false;
          botonComprar.textContent = botonComprar.getAttribute('data-texto-disponible') || 'Añadir a la cesta';
        } else {
          botonComprar.disabled = true;
          botonComprar.textContent = botonComprar.getAttribute('data-texto-agotado') || 'Agotado';
        }
      }
      if (encontrada.imagen) {
        var galeria = form.closest('.ob-producto-grid') ? form.closest('.ob-producto-grid').querySelector('[data-ob-galeria]') : document.querySelector('[data-ob-galeria]');
        if (galeria) {
          var principal = galeria.querySelector('[data-ob-galeria-principal]');
          if (principal && principal.src.indexOf(encontrada.imagen.split('?')[0]) === -1) {
            principal.style.opacity = '0';
            setTimeout(function () {
              principal.src = encontrada.imagen;
              principal.style.opacity = '1';
            }, 140);
          }
          var thumbs = galeria.querySelectorAll('[data-ob-galeria-thumb]');
          thumbs.forEach(function (t) {
            var full = (t.getAttribute('data-full') || '').split('?')[0];
            var match = encontrada.imagen.split('?')[0];
            t.classList.toggle('ob-thumb-activo', full === match);
          });
        }
      }
    }

    selects.forEach(function (s) { s.addEventListener('change', actualizar); });
    actualizar();
  });
}

// Fecha estimada de entrega en la ficha compacta. Días laborables por defecto; con data-naturales="1" cuenta días naturales
// y, si hay data-limite (AAAA-MM-DD), avisa cuando la entrega pasa de esa fecha (sin impedir la compra).
function initFechasEnvio() {
  document.querySelectorAll('[data-ob-envio-fechas]').forEach(function (el) {
    var min = parseInt(el.getAttribute('data-min'), 10) || 3;
    var max = parseInt(el.getAttribute('data-max'), 10) || 15;
    var naturales = el.getAttribute('data-naturales') === '1';
    var plantilla = el.getAttribute('data-txt') || '';
    function sumar(n) {
      var d = new Date();
      if (naturales) { d.setDate(d.getDate() + n); return d; }
      while (n > 0) {
        d.setDate(d.getDate() + 1);
        if (d.getDay() !== 0 && d.getDay() !== 6) n--;
      }
      return d;
    }
    var fmt;
    try { fmt = new Intl.DateTimeFormat(document.documentElement.lang || 'es', { weekday: 'short', day: 'numeric', month: 'short' }); } catch (e) { return; }
    var dMin = sumar(min), dMax = sumar(max);
    el.textContent = plantilla.replace('{a}', fmt.format(dMin)).replace('{b}', fmt.format(dMax));
    var limite = el.getAttribute('data-limite');
    if (limite) {
      var L = new Date(limite + 'T23:59:59');
      var msg = dMin > L ? el.getAttribute('data-aviso-tarde') : (dMax > L ? el.getAttribute('data-aviso-posible') : '');
      var prev = el.parentNode.querySelector('.ob-info__aviso');
      if (prev) prev.remove();
      if (msg) {
        var av = document.createElement('span');
        av.className = 'ob-info__aviso';
        av.setAttribute('role', 'status');
        av.style.cssText = 'display:block;margin-top:4px;color:#E8806F;font-weight:600;font-size:13px;';
        av.textContent = '\u26A0 ' + msg;
        el.insertAdjacentElement('afterend', av);
      }
    }
  });
}

